import Button from '@/components/Button'
import { useEffect, useState, useCallback } from 'react'
import { useRouter } from 'next/router'
import analytics from '@/utils/analytics'
import { Save, HelpCircle } from 'react-feather'

export default function ActionHeader({ showTutorial, annotations }) {
  return (
    <div className="w-full p-2 flex justify-end">
      <ShowTutorialButton showTutorial={showTutorial} />
      <SaveDemoButton annotations={annotations} />
    </div>
  )
}

function ShowTutorialButton({ showTutorial }) {
  return (
    <Button
      className="mr-3"
      onClick={() => {
        showTutorial()
        analytics.track('(Demo) Tutorial clicked')
      }}
    >
      <HelpCircle className="mr-3" />
      Tutorial
    </Button>
  )
}

function SaveDemoButton({ annotations }) {
  const [isLoading, setIsLoading] = useState(false)
  const router = useRouter()

  const onBeforeUnload = useCallback((e) => {
    e.preventDefault()
    e.returnValue = ''
    return
  }, [])

  useEffect(() => {
    window.addEventListener('beforeunload', onBeforeUnload)

    return () => window.removeEventListener('beforeunload', onBeforeUnload)
  }, [onBeforeUnload])

  function onSave() {
    setIsLoading(true)
    analytics.track('(Demo) Video saved')
    window.removeEventListener('beforeunload', onBeforeUnload)
    window.localStorage.setItem('demoAnnotations', JSON.stringify(annotations))
    router.replace('/login')
  }

  return (
    <Button isLoading={isLoading} onClick={onSave}>
      <Save className="mr-3" />
      Save
    </Button>
  )
}
